export default {
  offer: {
    title: 'Hallo {name}, super Nachrichten!',
    subTitle:
      'Wir haben das Erlebnis: {title} für Dich reserviert. Schließe nun den Kauf ab.',
    minMaxTickets: 'Für {tickets} Personen',
    otherDates: 'Andere Termine?',
    backToPreselected: 'Zurück zu den verfügbaren Terminen',
    pricePerPerson: 'Preis pro Person:',
    addOnsPrice: 'Extras:',
    priceTotal: 'Gesamt:',
    notAvailable: {
      title: 'Angebot nicht verfügbar',
      message:
        'Dieses Angebot ist derzeit nicht verfügbar. Bitte wähle einen anderen Termin auf der Erlebnisseite.',
    },
  },
}
